import { useLoading as loading } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css';

export const useLoading = () => {
    const $loading = loading({

    });
    let loader: any = null;
    const show = () => {
        loader = $loading.show();
    }
    return {
        show,
        hide() {
            if (loader) {
                loader.hide();
            }
        }
    }
}